const levels = state => state.levels;

export {
  levels,
}